// timer.ts ↔ game/timer.cpp's CLIENT arm — gtimm, the presentation TimerMgr.
// The full TimerMgr/Timer structure is already ported (and ledger-proven) in
// sim/src/sm/timer.ts with an abstract clock (the sim overrides GetTickCount
// with deterministic sim ticks). The client's gtimm is the SAME machine over
// the HOST clock (game/timer.cpp:53-63 GetTickCount -> HostGetTickCount,
// 1/100s ticks) — injected so harnesses can pin presentation time.

import { Timer, TimerMgr as TimerMgrBase } from '../../../sim/src/sm/timer.ts';

export { Timer };

/** The C++ `class X : public Form/Control, public Timer` multiple-inheritance
 *  arm: UI classes hold one of these and route OnTimer back to themselves. */
export class CallbackTimer extends Timer {
  private readonly cb: (tCurrent: number) => void;
  constructor(cb: (tCurrent: number) => void) {
    super();
    this.cb = cb;
  }
  override OnTimer(tCurrent: number): void {
    this.cb(tCurrent);
  }
}

export class TimerMgr extends TimerMgrBase {
  private readonly clock: () => number;

  /** clock = HostGetTickCount (1/100s ticks). */
  constructor(clock: () => number) {
    super();
    this.clock = clock;
  }

  override GetTickCount(): number {
    return this.clock();
  }
}

// game/ht.h:502-505
export interface ITimeout {
  OnTimeout(id: number): void;
}

/** game/ht.h:508-550 — TimeoutTimer: a cms-shaped one-shot/repeating timer over
 *  ITimeout. The C++ reaches the gtimm global; here the mgr is injected. */
export class TimeoutTimer extends Timer {
  private readonly timm: TimerMgr;
  private m_ptimo: ITimeout | null = null;
  private m_fOneShot = true;
  private m_id = 0;

  constructor(timm: TimerMgr) {
    super();
    this.timm = timm;
  }

  Start(ptimo: ITimeout, cms: number, id = 0, fOneShot = true): void {
    if (this.m_ptimo !== null) this.Stop();
    this.m_id = id;
    this.m_fOneShot = fOneShot;
    this.m_ptimo = ptimo;
    this.timm.AddTimer(this, Math.trunc(cms / 10));
  }

  Stop(): void {
    if (this.m_ptimo === null) return;
    this.timm.RemoveTimer(this);
    this.m_ptimo = null;
  }

  IsStarted(): boolean {
    return this.m_ptimo !== null;
  }

  override OnTimer(_tCurrent: number): void {
    const ptimo = this.m_ptimo!;
    if (this.m_fOneShot) this.Stop();
    ptimo.OnTimeout(this.m_id);
  }
}
